import React from "react";
import { MDBContainer } from "mdbreact";
import { Helmet } from "react-helmet";
import ReactMarkdown from "react-markdown";

import Layout from "../../components/Layout";
import LightboxPage from "../../components/LightboxPage";

import signwriter from "../../images/headers/3DHeader.jpg";

import text from "../../text/text.json"

import ColourImage from "../../components/ColourImage";

import pic1 from "../../images/3D&ILLUMINATED/01 3D (3-4).jpg";
import pic2 from "../../images/3D&ILLUMINATED/02-3D-(4-3).jpg";
import pic3 from "../../images/3D&ILLUMINATED/03-3D-(4-3).jpg";
import pic4 from "../../images/3D&ILLUMINATED/04 3D (2-1).jpg";
import pic5 from "../../images/3D&ILLUMINATED/05-3D-(3-2).jpg";
import pic6 from "../../images/3D&ILLUMINATED/06 3D (2-3).jpg";
import pic7 from "../../images/3D&ILLUMINATED/07 3D (5-3).jpg";
import pic8 from "../../images/3D&ILLUMINATED/08-3D-(2-1).jpg";
import pic9 from "../../images/3D&ILLUMINATED/09-3D-(2-1).jpg";
import pic10 from "../../images/3D&ILLUMINATED/10-3D (4-3).jpg";
import pic11 from "../../images/3D&ILLUMINATED/11 3D (5-2).jpg";
import pic12 from "../../images/3D&ILLUMINATED/12 3D (2-5).jpg";
import pic13 from "../../images/3D&ILLUMINATED/13 3D (2-4).jpg";
import pic14 from "../../images/3D&ILLUMINATED/14-3D-(5-3).jpg";
import pic15 from "../../images/3D&ILLUMINATED/15-3D-(3-4).jpg";
import pic16 from "../../images/3D&ILLUMINATED/16-3D-(4-2).jpg";

const photos = [
    {
        src: pic1,
        width: 3,
        height: 4
    },
    {
        src: pic2,
        width: 4,
        height: 3
    },
    {
        src: pic3,
        width: 4,
        height: 3
    },
    {
        src: pic4,
        width: 2,
        height: 1
    },
    {
        src: pic5,
        width: 3,
        height: 2
    },
    {
        src: pic6,
        width: 2,
        height: 3
    },
    {
        src: pic7,
        width: 5,
        height: 3
    },
    {
        src: pic8,
        width: 2,
        height: 1
    },
    {
        src: pic9,
        width: 2,
        height: 1
    },
    {
        src: pic10,
        width: 4,
        height: 3
    },
    {
        src: pic11,
        width: 5,
        height: 2
    },
    {
        src: pic12,
        width: 2,
        height: 5
    },
    {
        src: pic13,
        width: 2,
        height: 4
    },
    {
        src: pic14,
        width: 5,
        height: 3
    },
    {
        src: pic15,
        width: 3,
        height: 4
    },
    {
        src: pic16,
        width: 4,
        height: 2
    }
];

function threeDLetteringIlluminated() {

    return (
        <>
            <Helmet>
                <title>Artistic Wizard | 3D Lettering and Illuminated</title>
            </Helmet>
            <Layout>
                <ColourImage text="" overlay="" image={signwriter} />
                <MDBContainer style={{ padding: "20px" }}>
                    <ReactMarkdown>{text.threeDLetteringIlluminated.header1}</ReactMarkdown>
                    <ReactMarkdown>{text.threeDLetteringIlluminated.body1}</ReactMarkdown>
                    <ReactMarkdown>{text.threeDLetteringIlluminated.body2}</ReactMarkdown>
                    <ReactMarkdown>{text.threeDLetteringIlluminated.body3}</ReactMarkdown>
                    <ReactMarkdown>{text.threeDLetteringIlluminated.body4}</ReactMarkdown>
                    <ReactMarkdown>{text.threeDLetteringIlluminated.item1}</ReactMarkdown>
                    <ReactMarkdown>{text.threeDLetteringIlluminated.item2}</ReactMarkdown>
                    <ReactMarkdown>{text.threeDLetteringIlluminated.item3}</ReactMarkdown>
                    <ReactMarkdown>{text.threeDLetteringIlluminated.item4}</ReactMarkdown>
                    <ReactMarkdown>{text.threeDLetteringIlluminated.item5}</ReactMarkdown>
                    <ReactMarkdown>{text.threeDLetteringIlluminated.item6}</ReactMarkdown>
                    <ReactMarkdown>{text.threeDLetteringIlluminated.item7}</ReactMarkdown>
                    <ReactMarkdown>{text.threeDLetteringIlluminated.item8}</ReactMarkdown>
                    <ReactMarkdown>{text.threeDLetteringIlluminated.body5}</ReactMarkdown>
                    <br />
                    <LightboxPage images={photos} />
                </MDBContainer>
            </Layout>
        </>
    )
}

export default threeDLetteringIlluminated;